import { render, staticRenderFns } from "./signup-button-modal.vue?vue&type=template&id=d5e45b9a&scoped=true"
import script from "./signup-button-modal.vue?vue&type=script&lang=js"
export * from "./signup-button-modal.vue?vue&type=script&lang=js"
import style0 from "./signup-button-modal.vue?vue&type=style&index=0&id=d5e45b9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5e45b9a",
  null
  
)

export default component.exports